const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_URL ||
  process.env.REACT_APP_STRAPI_API_URL ||
  "http://167.86.75.204:1341";

const FORMAT_PREFERENCE = ["small", "medium", "thumbnail", "large"];

export const getStrapiImageUrl = (image, preferredSize = "small") => {
  if (!image) return "";

  const formats = image.formats || {};
  const formatCandidates = [
    formats[preferredSize],
    ...FORMAT_PREFERENCE.filter((size) => size !== preferredSize).map(
      (size) => formats[size]
    ),
  ];

  const format = formatCandidates.find(Boolean);
  const url = format?.url || image.url;
  if (!url) return "";

  return url.startsWith("http") ? url : `${STRAPI_BASE_URL}${url}`;
};
